import { isV2PlatformSource } from '@/utils/platformMigrationHelper';

// iframe-view lives in localStorage, so a stored source survives a refresh and a new tab.
// fromV2 stays in sessionStorage. It is only a fallback for embeds saved before source was stored.
export function readIframeView(raw) {
  try {
    const view = raw && raw.length ? JSON.parse(raw) : null;
    return {
      isIframe: !!(view && view.closeCta === true),
      isV2Embed: !!(view && isV2PlatformSource(view.source)),
    };
  } catch (e) {
    return { isIframe: false, isV2Embed: false };
  }
}

// An older V2 session has iframe-view without source. Count it as V2, and return
// the iframe-view string to store so the next tab does not depend on the session.
export function resolveEmbedFlags(raw, fromV2Session) {
  const flags = readIframeView(raw);
  if (!fromV2Session || !flags.isIframe || flags.isV2Embed) {
    return { isIframe: flags.isIframe, isV2Embed: flags.isV2Embed, nextIframeView: null };
  }
  try {
    const view = JSON.parse(raw);
    view.source = process.env.VUE_APP_V2_PLATFORM_SOURCE || 'v2-platform';
    return { isIframe: true, isV2Embed: true, nextIframeView: JSON.stringify(view) };
  } catch (e) {
    return { isIframe: true, isV2Embed: true, nextIframeView: null };
  }
}

// One decision for every page. A V2 embed keeps the web header, including on
// orders and order-complete. Any other embed keeps the native back button,
// including on the shop.
export function orgOwnerEmbedChrome({ isIframe, isV2Embed, showCloseCta, showCart }) {
  return {
    shouldShowNavbar: !isIframe || !!isV2Embed,
    shouldShowCloseCta: !!showCloseCta && !isV2Embed,
    shouldShowCartInHeader: !!isIframe && !!showCart && !isV2Embed,
  };
}
